import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import Select from 'components/v2/Select'

export default function TicketTypeSelect(props) {
  const fetch = async where => {
    //console.log(where)
    const { ticketTypes } = await fetchQuery(
      graphql`
        query TicketTypeSelectQuery($where: TicketTypeWhere) {
          ticketTypes(where: $where, orderBy: [code], order: ASC) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      `,
      { where }
    )

    return ticketTypes.edges.map(({ node }) => ({
      key: node.id,
      value: node.id,
      text: node.name,
    }))
  }

  return (
    <Select
      {...props}

      getByValue={value => {

        return fetch([{ id: { eq: value }, isDisabled: { eq: 'false' } }])
      }
      }

      loadOptions={
        searchQuery => {
          const conditions = [{ isDisabled: { eq: 'false' } }]

          if (searchQuery !== undefined)
            conditions.push({ name: { iLike: `${searchQuery}%` } })
          //if (companyId) conditions.push({ companyId: { eq: companyId } })

          return fetch({ and: conditions })
        }
        /* searchQuery => fetch([{ name: { iLike: `${searchQuery}%` }, isDisabled: { eq: 'false' } }]) */

      }
    />
  )
}

TicketTypeSelect.defaultProps = {
  label: 'Tipo de Ticket',
  placeholder: 'Tipo de Ticket',
  loadOnMount: true,
  multiple: false,
}
